var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import S from './style/styled';
import { Label } from '../../composition/typography';
import { Icon } from '../../ui/icon';
import { User } from '../../ui/icon/iconList/fontIcons';
import { Title } from '../../composition/typography';
import RatioDataLogo from './style/logo';
export var Header = function Header(_a) {
  var appTitle = _a.appTitle,
      headerLink = _a.headerLink,
      userName = _a.userName,
      menu = _a.menu,
      style = _a.style,
      extraProps = __rest(_a, ["appTitle", "headerLink", "userName", "menu", "style"]);

  var defaultAppTitle = 'ratioData';
  var defaultUserName = 'defaultUserName';
  return React.createElement(S.HeaderContainerStyle, Object.assign({
    style: style
  }, extraProps), React.createElement(S.HeaderLeftSide, null, React.createElement(S.LogoContainer, null, React.createElement(RatioDataLogo, null)), React.createElement(S.HeaderTitle, {
    appTitle: appTitle
  }, React.createElement(Title, {
    tag: 'h5'
  }, appTitle || defaultAppTitle))), React.createElement(S.HeaderCenterArea, null, menu && menu), React.createElement(S.HeaderRightSide, null, React.createElement(S.UserContainer, {
    userName: userName,
    headerLink: headerLink
  }, React.createElement(Icon, {
    src: React.createElement(User, null)
  }), React.createElement(Label, {
    size: "large"
  }, userName || defaultUserName)), React.createElement(S.LinkContainer, null, headerLink ? React.createElement(React.Fragment, null, React.createElement(S.SeparatorLine, null), React.createElement(S.LinkContainer, {
    headerLink: headerLink
  }, headerLink), React.createElement(S.SeparatorLine, null)) : null)));
};